import { render, staticRenderFns } from "./AbsenceUnJustifiedWidget.vue?vue&type=template&id=20becf76&scoped=true&"
import script from "./AbsenceUnJustifiedWidget.vue?vue&type=script&lang=js&"
export * from "./AbsenceUnJustifiedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20becf76",
  null
  
)

export default component.exports